const onLoad = async () => {
    console.log('onLoad');

    ('use strict');

    /* ---------------------- MENU --------------------- */

    const $navBtn = document.querySelector('.nav-btn');
    if ($navBtn) {
        $navBtn.addEventListener('click', () => {
            const $navMenu = document.querySelector('.nav-menu');
            if ($navMenu) {
                if ($navMenu.classList.contains('active')) {
                    $navMenu.classList.remove('active');
                } else {
                    $navMenu.classList.add('active');
                }
            }
            if ($navBtn.classList.contains('active')) {
                $navBtn.classList.remove('active');
            } else {
                $navBtn.classList.add('active');
            }
            const $body = document.querySelector('body');
            if ($body) {
                if ($body.classList.contains('no-scroll')) {
                    $body.classList.remove('no-scroll');
                } else {
                    $body.classList.add('no-scroll');
                }
            }
        });
    }

    /* --------------------- TO TOP -------------------- */
    const $toTop = document.querySelector('.to-top');

    document.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 500) {
            $toTop?.classList.add('active');
        } else {
            $toTop?.classList.remove('active');
        }
    });

    if ($toTop) {
        $toTop.addEventListener('click', () => {
            scroll({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', onLoad);
